import { render } from "./customButton.vue?vue&type=template&id=e6cadd8a"
import script from "./customButton.vue?vue&type=script&lang=js"
export * from "./customButton.vue?vue&type=script&lang=js"

import "./customButton.vue?vue&type=style&index=0&id=e6cadd8a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__